import { useToggle } from "client/hooks/utils/useToggle";
import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { DEFAULT_TOAST_SHOW_TIME } from "components/common/Toast/ToastRenderer";
import { useToast } from "components/common/Toast/useToast";
import { useDispatch } from "react-redux";
import { deleteAllImages } from "store/features/compress/actions";

export const useDeleteAll = () => {
    const { isOpen, open, onClose: close } = useToggle();
    const dispatch = useDispatch();
    const { toast } = useToast();
    const deleteSuccessText = capitalize(translateFunc("delete-successful"));

    const handleDeleteAll = () => {
        dispatch(deleteAllImages());
        close();
        toast({
            closeable: true,
            position: "top-right",
            status: "success",
            text: deleteSuccessText,
            time: DEFAULT_TOAST_SHOW_TIME,
        });
    };

    return {
        isOpen,
        open,
        close,
        handleDeleteAll,
    };
};
